<!-- Section: Team v.1 -->
<section class="text-center my-5">

 

    <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
        <mdb-carousel-item  *ngFor='let img of ["hof_640.jpg","hase_640.jpg","kunst_640.jpg","tgp_640.jpg","glas_640.jpg","farben_640.jpg","raum.jpg"]'>
            <div class="view w-100">
                <img class="d-block w-100"  src="../../assets/img/gallery/{{img}}"
                  style="object-fit: cover;
            width: auto;
            max-height: 80vh;">
                <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
            </div>
            <div class="carousel-caption">
                <h3 class="h3-responsive"> </h3>
               
            </div>
        </mdb-carousel-item>
       

    </mdb-carousel>

</section>